/**
 * @generated SignedSource<<79a0cdd7ee2afc84c8e92a9c54ebe910>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailShipping_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoWrapper_user">;
  readonly " $fragmentType": "PdpSharedDetailShipping_user";
};
export type PdpSharedDetailShipping_user$key = {
  readonly " $data"?: PdpSharedDetailShipping_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailShipping_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailShipping_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "afccbbe303fd03b9369ba8b0078b0ddb";

export default node;
